// Seletor de arquivos com botão visível (épico PO1-3359). O tema black-dashboard deixa o
// input[type=file] dentro de .form-group com opacidade 0 (clicável, mas invisível), então o
// input nativo fica oculto e o botão "Escolher arquivos" é o que a pessoa vê.
import React, { useRef } from "react";
import { Button } from "reactstrap";

export default function EscolherArquivos({ accept, multiple, onSelecionar, disabled, ariaLabel, rotulo }) {
  const ref = useRef(null);
  return (
    <div>
      <input
        ref={ref}
        type="file"
        accept={accept}
        multiple={multiple}
        style={{ display: "none" }}
        aria-label={ariaLabel}
        disabled={disabled}
        onChange={(e) => {
          onSelecionar(e.target.files);
          e.target.value = "";
        }}
      />
      <Button type="button" color="info" size="sm" outline onClick={() => ref.current && ref.current.click()} disabled={disabled}>
        {rotulo || "Escolher arquivos"}
      </Button>
    </div>
  );
}
